module.exports = __webpack_public_path__ + "img/Quimica II.daf0b820.png";